<script lang="ts" setup>
import { computed } from 'vue';
import type { PI_PAGES_CARS } from '@sccs/one-teaser/app-types';

import { useSectionsStore } from '@/stores/sections';
import ClientOnly from '@dh-io-owpi/shared/src/components/ClientOnly/ClientOnly.vue';
import { useOptionalLoaderData } from '@/composables/useLoaderData';
import { useCurrentBrandId } from '@/stores/vehicle/helpers';
import { useAemData } from '@/composables/useAemData';

import { getBM4 } from './vmds';
import { useOneTeaser } from './OneTeaser';

const aemData = useAemData();
const sectionsStore = useSectionsStore();
const loaderData = useOptionalLoaderData();
const brand = useCurrentBrandId();

function handleError() {
  sectionsStore.handleError(['offerTeaser'], new Error('OneTeaser triggered an error. Maybe not enough vehicles?'));
}
// on Error fallback mode get bm4 from vmds
let bm4 = loaderData?.bm4 ?? (await getBM4(aemData).catch(handleError));

/** https://git.i.mercedes-benz.com/dh-io-sccs/air-tnt/blob/develop/packages/vehicle-tile/src/types/AppTypes.ts#L37 */
type Appearance = 'workbench7' | 'overlapping' | 'campaign';
const appearance: Appearance = 'overlapping';

const settings = computed<PI_PAGES_CARS>(() => ({
  mode: 'PI_PAGES_CARS' as any, // Mode.PI_PAGES_CARS,
  bm4,
  useCurrentEnv: false,
  brand: brand.value,
  appearance,
}));
const OneTeaser = useOneTeaser();
</script>

<template>
  <ClientOnly>
    <OneTeaser class="owpi-spa-offer-teaser" :settings @error="handleError" />
  </ClientOnly>
</template>

<style lang="scss">
.owpi-spa-offer-teaser {
  min-height: 770px;
  padding: 0 !important; // override the padding from the one-teaser component
}
</style>
